module.exports = __webpack_public_path__ + "img/answer-c4-3.9f8cfee8.png";